import { notification } from '../reducers/notification.reducer';
import { 
  makeGETRequest, 
  makeFormDataPOSTRequest, 
  makeDELETERequest, 
  makeFormDataPUTRequest, 
  controlledGETRequest, 
  createCancelToken, 
  makePUTRequest,
  controlledFormDataPUTRequest
} from '../utils/Axios';

export const notification_filterActions = {
  getNotificationFilter,
  updateNotificationFilter
};

export function getNotificationFilter({
  cancel_token = createCancelToken().token,
  ...props
}) {
  return function (dispatch) {
    try{
      controlledGETRequest(`/api/v1/notification_filter_settings`, cancel_token)
      .then(response => {
        if(response.data.status === "ok"){
            props?.onSuccess?.(response)
        }else {
            props?.onError?.(response)
        }
      })
    }catch(e){
      dispatch( {
        type: notification_filterActions.NOTIFICATION_FILTER_FAILURE,
        payload: console.log(e),
      })
    }
  }
}


export function updateNotificationFilter({
    id,
    formData,
    cancel_token = createCancelToken().token,
    ...props
}) {
  return function (dispatch) {
    try{
      controlledFormDataPUTRequest(`/api/v1/notification_filter_settings/${id}`, cancel_token, { notification_filter_setting: formData })
      .then(response => {
        if(response.data.status === "ok"){
            props?.onSuccess?.(response)
        }else {
            props?.onError?.(response)
        }
      })
    }catch(e){
      dispatch( {
        type: notification_filterActions.NOTIFICATION_FILTER_FAILURE,
        payload: console.log(e),
      })
    }
  }
}
